import { makeStyles } from "tss-react/mui";
import { MiCheckbox } from "@miplatform/components";
import { Box, Typography } from "@mui/material";

export const AttemptEmailAttachments = ({
  documents = [],
  selectedDocumentIds = [],
  onDocumentToggle,
}) => {
  const { classes } = useStyles();
  const selectedIds = new Set(selectedDocumentIds);

  return (
    <Box className={classes.container}>
      <Typography className={classes.label}>Attach Camera Videos</Typography>
      <Box className={classes.documents}>
        {documents.map((document) => {
          const documentId = document.id || document.referenceId;

          return (
            <MiCheckbox
              key={documentId}
              label={document?.title}
              name={`camera-video-${documentId}`}
              value={selectedIds.has(documentId)}
              handleChange={() => onDocumentToggle(documentId)}
            />
          );
        })}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(0, 1, 4),
  },
  label: {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(1),
  },
  documents: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));
